<template>
    <div class="row">
        <div class="col-12">
          <div class="card-header-actions">
            <div class="col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
              <button class="all-btn add-btn pull-right" @click="showRentalRatesForIndividualModal(null)">{{$t("action.add")}}</button>
            </div>
          </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                  <tr>
                      <th>#</th>
                      <th>Категория</th>
                      <th>Тошкент шаҳри</th>
                      <th>Нукус шаҳри ва вилоят марказларидаги шаҳарлар</th>
                      <th>Бошқа аҳоли пунктлари</th>
                      <!--<th class="text-center">{{$t("realEstate.field.action")}}</th>-->
                  </tr>
                  </thead>
                  <tbody v-if="!loading && results && results.data">
                  <tr v-for="result in results.data" :key="result.id">
                      <td>{{result.id}}</td>
                      <td>{{result.data.category}}</td>
                      <td>{{result.data.rentPaymentCity}}</td>
                      <td>{{result.data.rentPaymentProvinceCity}}</td>
                      <td>{{result.data.rentPaymentOtherRegion}}</td>
                      <!--<td class="td-actions text-center">-->
                          <!--<button class="all-btn edit-btn table-action" data-original-title="Edit" @click="showRentalRatesForIndividualModal(result)">-->
                              <!--<i class="fa fa-edit"></i>-->
                          <!--</button>-->
                          <!--<button class="all-btn delete-btn table-action" @click="deleteField(result.id)">-->
                              <!--<i class="fa fa-remove"></i>-->
                          <!--</button>-->
                      <!--</td>-->
                  </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <RentalRatesForIndividualEditModal @change="initList"></RentalRatesForIndividualEditModal>
    </div>
</template>

<script>
    import RentalRatesForIndividualEditModal from '@/views/config/rental_rates/RentalRatesForIndividualEditModal'
    import initFilterModel from '@/shared/filter';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    export default {
        components: {
            RentalRatesForIndividualEditModal,
            'b-pagination': bPagination
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null
            }
        },
        methods: {
            showRentalRatesForIndividualModal(data) {
                this.$eventBus.$emit('showRentalRatesForIndividualModal',data)
            },
            initList() {
                this.loading = true;
                const vm = this;
                this.$http.post('dictionary/list/RENTAL_RATES_FOR_INDIVIDUAL', this.filter)
                    .then(res => {
                        this.results = res.data;
                        vm.loading = false;
                    }, err => {
                        console.log(err);
                        vm.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            }
        },
        created() {
            this.initList();
        }
    }
</script>

<style scoped>

</style>